module.exports = __webpack_public_path__ + "img/icon_pdf_statement@2x.6eae12c4.png";